<template>
  <div class="electronInductionManagement-container">
    <v-header title="入司管理"></v-header>
    <el-container class="container" v-if="show">
      <el-header>
        <el-row :gutter="20">
          <el-col :span="6">
            <div>
              <label class="title">机构：</label>
              <el-cascader
                v-model="queryParams.t3"
                :options="manageComNameOptions"
                :show-all-levels="false"
                clearable
                size="small"
                placeholder="请选择机构"
                @change="handleChange">
              </el-cascader>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <label class="title">姓名：</label>
              <el-input size="small" v-model="queryParams.name"
                        @input="queryParams.name=queryParams.name.replace(/[^a-zA-Z\u4E00-\u9FA5]/g,'')" maxlength="30"
                        clearable
                        placeholder="请输入姓名"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <label class="title">证件类型：</label>
              <el-select size="small" v-model="queryParams.idType" clearable
                         placeholder="请选择证件类型">
                <el-option v-for="item in idTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <label class="title">证件号码：</label>
              <el-input size="small" v-model="queryParams.idNo"
                        @input="queryParams.idNo=queryParams.idNo.replace(/[^a-zA-Z0-9]/g,'')" maxlength="30"
                        clearable placeholder="请输入证件号码"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div>
              <label class="title">移动电话：</label>
              <el-input size="small" v-model="queryParams.phone" maxlength="11" clearable
                        placeholder="请输入电话"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <label class="title">状态：</label>
              <el-select size="small" v-model="queryParams.status" clearable
                         placeholder="请选择状态">
                <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <label class="title">提交时间：</label>
              <el-date-picker size="small" v-model="queryParams.submissionTimeStart"
                              @change="changeDate(queryParams.submissionTimeStart, 1)" type="date"
                              value-format="yyyy-MM-dd" :editable="false"
                              :picker-options="pickerOptionsSubmitStart" placeholder="起始日期"></el-date-picker>
              <span>&nbsp;至&nbsp;</span>
              <el-date-picker size="small" v-model="queryParams.submissionTimeEnd"
                              @change="changeDate(queryParams.submissionTimeEnd, 2)" type="date"
                              value-format="yyyy-MM-dd" :editable="false"
                              :picker-options="pickerOptionsSubmitEnd" placeholder="截止日期"></el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div>
              <label class="title">创建时间：</label>
              <el-date-picker size="small" v-model="queryParams.createDateStart"
                              @change="changeDate(queryParams.createDateStart, 3)" type="date"
                              value-format="yyyy-MM-dd" :editable="false"
                              :picker-options="pickerOptionsCreatedStart" placeholder="起始日期"></el-date-picker>
              <span>&nbsp;至&nbsp;</span>
              <el-date-picker size="small" v-model="queryParams.createDateEnd"
                              @change="changeDate(queryParams.createDateEnd, 4)" type="date"
                              value-format="yyyy-MM-dd" :editable="false"
                              :picker-options="pickerOptionsCreatedEnd" placeholder="截止日期"></el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <div>
              <el-button type="primary" size="small" @click="searchFunc">查询</el-button>
              <el-button type="info" size="small" @click="resetFunc">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>

      <el-main>
        <el-table
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :data="tableData"
          border
          height="500"
          stripe="true"
          style="width: 100%">
          <el-table-column
            fixed
            align="center"
            prop="manageCom"
            show-overflow-tooltip="true"
            width="150"
            label="机构">
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="name"
            width="120"
            show-overflow-tooltip="true"
            label="姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sex"
            show-overflow-tooltip="true"
            width="120"
            label="性别">
          </el-table-column>
          <el-table-column
            align="center"
            prop="idType"
            width="120"
            label="证件类型">
          </el-table-column>
          <el-table-column
            align="center"
            prop="idNo"
            width="200"
            show-overflow-tooltip="true"
            label="证件号码">
          </el-table-column>
          <el-table-column
            align="center"
            prop="idStartDate"
            width="150"
            show-overflow-tooltip="true"
            label="证件有效期起期">
          </el-table-column>
          <el-table-column
            align="center"
            prop="idEndDate"
            width="150"
            show-overflow-tooltip="true"
            :formatter="formatter"
            label="证件有效期止期">
          </el-table-column>
          <el-table-column
            align="center"
            prop="birthday"
            width="150"
            show-overflow-tooltip="true"
            label="出生日期">
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobile"
            width="150"
            show-overflow-tooltip="true"
            label="移动电话">
          </el-table-column>
          <el-table-column
            align="center"
            prop="degree"
            width="150"
            show-overflow-tooltip="true"
            label="学历">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nativePlace"
            width="150"
            show-overflow-tooltip="true"
            label="籍贯">
          </el-table-column>
          <el-table-column
            align="center"
            prop="validatorCode"
            width="180"
            show-overflow-tooltip="true"
            label="创建入司人员编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="state"
            width="150"
            show-overflow-tooltip="true"
            label="状态">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createDate"
            width="180"
            show-overflow-tooltip="true"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="submissionTime"
            width="180"
            show-overflow-tooltip="true"
            label="提交时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            width="180"
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="viewDetailsFunc(scope.row)">查看详情</el-button>
              <el-button type="text" @click="exportFunc(scope.row.businessNo)" v-if="scope.row.state == '已完成'">资料下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>

      <el-footer>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.offset"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-footer>
    </el-container>

    <div class="container" v-if="!show">
      <el-descriptions title="基本信息" :column="5" :colon="false">
        <el-descriptions-item label="机构：">{{ detailsObj.manageCom }}</el-descriptions-item>
        <el-descriptions-item label="姓名：">{{ detailsObj.name }}</el-descriptions-item>
        <el-descriptions-item label="状态：">{{ detailsObj.state }}</el-descriptions-item>
        <el-descriptions-item label="入司节点：">{{ detailsObj.joinNode }}</el-descriptions-item>
        <el-descriptions-item label="证件类型：">{{ detailsObj.idType }}</el-descriptions-item>
        <el-descriptions-item label="证件号码：">{{ detailsObj.idNo }}</el-descriptions-item>
        <el-descriptions-item label="证件有效期起期：">{{ detailsObj.idStartDate }}</el-descriptions-item>
        <el-descriptions-item label="证件有效期止期：">{{ detailsObj.idEndDate }}</el-descriptions-item>
        <el-descriptions-item label="移动电话：">{{ detailsObj.mobile }}</el-descriptions-item>
        <el-descriptions-item label="性别：">{{ detailsObj.sex }}</el-descriptions-item>
        <el-descriptions-item label="学历：">{{ detailsObj.degree }}</el-descriptions-item>
        <el-descriptions-item label="籍贯：">{{ detailsObj.nativePlace }}</el-descriptions-item>
        <el-descriptions-item label="民族：">{{ detailsObj.nationality | filterNationality }}</el-descriptions-item>
        <el-descriptions-item label="省市区：">{{ detailsObj.province }}-{{ detailsObj.city }}-{{
            detailsObj.district
          }}
        </el-descriptions-item>
        <el-descriptions-item label="街道：">{{ detailsObj.street }}</el-descriptions-item>
        <el-descriptions-item label="邮编：">{{ detailsObj.zipCode }}</el-descriptions-item>
        <el-descriptions-item label="传真：">{{ detailsObj.fax }}</el-descriptions-item>
        <el-descriptions-item label="固定电话：">{{ detailsObj.phone }}</el-descriptions-item>
        <el-descriptions-item label="QQ：">{{ detailsObj.qQ }}</el-descriptions-item>
        <el-descriptions-item label="邮箱：">{{ detailsObj.email }}</el-descriptions-item>
        <el-descriptions-item label="微博：">{{ detailsObj.blog }}</el-descriptions-item>
        <el-descriptions-item label="微信：">{{ detailsObj.weChat }}</el-descriptions-item>
        <el-descriptions-item label="提交时间：">{{ detailsObj.submissionTime }}</el-descriptions-item>
        <el-descriptions-item label="创建时间：">{{ detailsObj.createDate }}</el-descriptions-item>
        <el-descriptions-item label="创建入司人员编号：">{{ detailsObj.validatorCode }}</el-descriptions-item>
        <el-descriptions-item label="完成时间：">{{ detailsObj.completeTime }}</el-descriptions-item>
        <el-descriptions-item label="最后一次操作时间：">{{ detailsObj.lastOperatingTime }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="签署文件及影像信息" :column="5" :colon="false" v-if="detailsObj.state == '已完成'">
        <el-descriptions-item>
          <el-button @click="exportFunc(detailsObj.businessNo)">资料下载</el-button>
        </el-descriptions-item>
      </el-descriptions>
      <br><br><br><br>
      <el-button type="primary" class="backBtn" @click="backFunc">返回</el-button>
    </div>
  </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import nationalityList from '@/assets/js/nationality'
import vHeader from '@/layout/Header1.vue'

export default {
  name: 'electronInductionManagement',
  components: {vHeader},
  data() {
    return {
      show: true, // 区分显示表示数据模块还是显示数据详情模块的变量
      manageComNameOptions: [], // 存储机构下拉菜单数据的集合
      // 存储证件类型下拉菜单数据的集合
      idTypeOptions: [{value: '1', label: '身份证'}, {value: '3', label: '护照'}, {value: '99', label: '其他'}],
      // 存储状态下拉菜单数据的集合
      stateOptions: [{value: '0', label: '待提交'}, {value: '1', label: '已提交'}, {value: '2', label: '已完成'}],
      token: '', // 设置存储token的变量
      // 定义查询条件的参数对象
      queryParams: {
        t2: '', // T2机构名称
        t3: '', // T3机构名称
        name: '', // 姓名
        idType: '', // 证件类型
        idNo: '', // 证件号码
        phone: '', // 电话
        status: '', // 状态
        submissionTimeStart: '', // 提交起始时间
        submissionTimeEnd: '', // 提交截止时间
        createDateStart: '', // 创建起始时间
        createDateEnd: '', // 创建截止时间
        offset: 1, // 每页展示的数据条数
        limit: 10 // 页码数，初始化默认为'1'
      },
      // 提交时间-设置时间范围选项中，截止时间不能早于起始时间的方法
      pickerOptionsSubmitStart: {
        disabledDate: time => {
          if (this.queryParams.submissionTimeEnd) {
            return time.getTime() > new Date(this.queryParams.submissionTimeEnd).getTime()
          }
        }
      },
      // 提交时间-设置时间范围选项中，起始时间不能晚于截止时间的方法
      pickerOptionsSubmitEnd: {
        // disabledDate: time => {
        //   return time.getTime() > Date.now() - 8.64e6;//如果不包括今天。就是return time.getTime() > Date.now() - 24*3600*1000;
        // },
        disabledDate: time => {
          if (this.queryParams.submissionTimeStart) {
            return time.getTime() < new Date(this.queryParams.submissionTimeStart).getTime()
          }
        }
      },
      // 创建时间--设置时间范围选项中，截止时间不能早于起始时间的方法
      pickerOptionsCreatedStart: {
        disabledDate: time => {
          if (this.queryParams.createDateEnd) {
            return time.getTime() > new Date(this.queryParams.createDateEnd).getTime()
          }
        }
      },
      // 创建时间-设置时间范围选项中，起始时间不能晚于截止时间的方法
      pickerOptionsCreatedEnd: {
        disabledDate: time => {
          if (this.queryParams.createDateStart) {
            return time.getTime() < new Date(this.queryParams.createDateStart).getTime()
          }
        }
      },
      tableData: [], // 定义存储表格数据的集合
      total: '', // 数据总条数
      loading: false, // 定义是否开启表格的加载遮罩的变量
      detailsObj: {}
    }
  },
  mounted() {
    // 开启表格加载遮罩层
    this.loading = true
    // 调用获取coookie中得token数据的方法
    this.getCookieData()
    // 调用查询获取机构下拉菜单数据集合的方法
    this.getManageComNameSelectDataFunc()
    // 为了防止接口异步调用问题，给查询获取表格数据的方法添加一个1.5秒的等待时间
    setTimeout(() => {
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    }, 1500)

  },
  methods: {
    /**
     * @Description: 格式化证件有效期止期的数据
     * @author:zhangqi
     * @Date:2022-07-12
     */
    formatter(row, column) {
      if (row[column.property] == '9999-12-31') {
        return '长期'
      } else {
        return row[column.property]
      }
    },

    /**
     * @Description: 获取coookie中得token数据的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    getCookieData() {
      // 先重置清空变量，防止数据有缓存
      this.token = ''
      let arr,
        reg = new RegExp('(^| )' + 'jtl' + '=([^;]*)(;|$)'),
        obj = document.cookie.match(reg);
      obj instanceof Array && (arr = obj);
      this.token = arr && unescape(arr[2])
    },

    /**
     * @Description: 查询获取机构下拉菜单数据集合的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    getManageComNameSelectDataFunc() {
      // 调用查询数据的接口，获取数据
      api.post(url.getOrgListInduction, {}, res => {
        if (res.result.isSuccess) {
          // 将数据赋值给存储业务来源下拉菜单数据的集合
          this.manageComNameOptions = res.data
        } else {
          this.$message({
            type: 'error',
            message: res.error
          });
        }
      })
    },

    /**
     * @Description: 切换选择的机构数据的方法
     * @params: value--选中节点的值
     * @author:zhangqi
     * @Date:2022-06-13
     */
    handleChange(value) {
      // 将选择的T2机构的机构代码，赋值给对应的变量
      this.queryParams.t2 = value[0]
      // 将选择的T3机构的机构代码，赋值给对应的变量
      this.queryParams.t3 = value[1]
    },

    /**
     * @Description: 选择时间范围时，将所选时间范围，分别赋值给起始时间与结束时间的方法
     * params: date--当前选择的时间范围数据
     * @author:zhangqi
     * @Date:2022-06-13
     */
    changeDate(date, sum) {
      if (date != null) {
        switch (sum) {
          case 1 :
            this.queryParams.submissionTimeStart = date + ' 00:00:00';
            break;
          case 2 :
            this.queryParams.submissionTimeEnd = date + ' 23:59:59';
            break;
          case 3 :
            this.queryParams.createDateStart = date + ' 00:00:00'
            break;
          case 4 :
            this.queryParams.createDateEnd = date + ' 23:59:59'
            break;
        }
      } else {
        switch (sum) {
          case 1 :
            this.queryParams.submissionTimeStart = '';
            break;
          case 2 :
            this.queryParams.submissionTimeEnd = '';
            break;
          case 3 :
            this.queryParams.createDateStart = '';
            break;
          case 4 :
            this.queryParams.createDateEnd = '';
            break;
        }
      }
    },

    /**
     * @Description: 查询获取表格数据的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    queryDataFunc() {
      // 调用查询表格数据的接口，获取数据
      api.post(url.queryListOfBank, this.queryParams, res => {
        if (res.result.isSuccess) {
          // 将数据赋值给存储表格数据的集合
          this.tableData = res.data.queryListOfBankVos
          // 将数据总条数赋值给对应的变量
          this.total = ~~res.data.size
        } else {
          this.$message({
            type: 'error',
            message: res.result.error
          });
        }
        // 关闭表格加载遮罩层
        this.loading = false
      })
    },

    /**
     * @Description: 点击查询按钮时，触发的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    searchFunc() {
      // 点击搜索时，要将页码数重置为1，因为查询的是从第一页开始的数据
      this.queryParams.offset = 1
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    },

    /**
     * @Description: 点击重置按钮时，触发的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    resetFunc() {
      Object.keys(this.queryParams).forEach(item => {
        this.queryParams[item] = ''
      })
      // 点击重置时，要将页码数重置为1，因为查询的是从第一页开始的数据
      this.queryParams.offset = 1
      // 点击重置时，将每页展示的条数设置成默认的10条
      this.queryParams.limit = 10
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    },

    /**
     * @Description: 点击查看详情按钮触发的方法
     * @params: rowData--表格中当前行的所有数据
     * @author:zhangqi
     * @Date:2022-06-13
     */
    viewDetailsFunc(rowData) {
      // 点击查看详情按钮，要展示详情数据模块
      this.show = false
      this.detailsObj = {}
      this.detailsObj = rowData
    },

    /**
     * @Description: 点击资料下载按钮时，触发的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    exportFunc(businessNo) {
      // 开启表格加载遮罩层
      this.loading = true
      api.post(url.inductionMaterialDownload, {businessNo}, res => {
        // 关闭表格加载遮罩层
        this.loading = false
        if (res.result.isSuccess === true) {
          window.location.href = res.data
        } else {
          this.$message.error(res.error)
        }
      })
    },

    /**
     * @Description: 查看详情模块部分中点击‘返回’按钮执行的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    backFunc() {
      this.show = true
    },

    /**
     * @Description: 切换当前页码时，触发的方法
     * @author:zhangqi
     * @Date:2022-06-13
     */
    handleCurrentChange(val) {
      // 切换页码后，将当前的页码数赋值给变量
      this.queryParams.offset = val
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    }
  },
  filters: {
    filterNationality: (value) => {
      if (!value) return ''
      value = value.toString()
      let nationalityText = ''
      let arrList = nationalityList.nationalityList[0].values
      arrList.forEach(item => {
        if (item.value == value) {
          nationalityText = item.text
        }
      })
      return nationalityText
    }
  }
}
</script>

<style lang="scss" scoped>
.electronInductionManagement-container {
  .headercom {
    position: relative;
  }

  /deep/ .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    padding-bottom: 15px;
    background: #FFFFFF;

    .el-descriptions {
      padding: 20px;

      .el-descriptions__header {
        .el-descriptions__title {
          font-size: 20px;
        }
      }

      .el-descriptions__body {
        .el-descriptions-item {
          padding-bottom: 15px;
        }

        .el-descriptions-item__label {
          font-size: 16px;
          font-weight: bold;
          color: #111111;
        }

        .el-descriptions-item__content {
          font-size: 16px;
        }
      }
    }

    .backBtn {
      display: block;
      margin-bottom: 20px;
      margin: 0 auto;

    }
  }

  .el-header {
    height: auto !important;

    .el-row {
      margin-top: 20px;
    }

    .el-input {
      width: 210px;
    }
  }

  .el-main {
    /deep/ thead {
      .el-table__cell {
        background: #F5F7FA;
      }
    }
  }

  .el-footer {
    text-align: right;
  }

  button {
    cursor: pointer;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/electronInduction/electronInductionManagement.vue